module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_question-1dc098132550d3cc52a3bef46c75ecc3.svg";